import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { User } from './types/User';
import { APIV2_URL } from './constants';

const impersonateUser = (makeCall: MakeCall) => (userId: number) =>
  makeCall<User>('PUT', `${APIV2_URL}/user/${userId}/impersonate`);

export default impersonateUser;
